// components/LanguageDropdown.js
import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const LanguageDropdown = () => {
  const { i18n } = useTranslation();

  const languages = [
    { value: 'ar', label: 'ar العربية' },
    { value: 'en', label: 'us	 English' },
    { value: 'it', label: '🇮🇹 Italiano' },
  ];
  const handleChange = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
  };

  const defaultValue = languages.find(lang => lang.value === i18n.language);

  return (
    <div  style={{ width: 150 , }}>
      <Select
        options={languages}
        onChange={handleChange}
        defaultValue={defaultValue}
        isSearchable={false}
      />
    </div>
  );
};

export default LanguageDropdown;
